import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {

  setLoggedInUser(value: any): void {
    localStorage.setItem('loggedInUser', JSON.stringify(value))
  }

  setAuthTokenInfo(value: any): void {
    localStorage.setItem('authTokenInfo', JSON.stringify(value))
  }

  getAuthTokenInfo(): any {
    const storedToken = localStorage.getItem('authTokenInfo');
    return storedToken ? JSON.parse(storedToken) : null;
  }

  getLoggedInUser(): any {
    const storedUser = localStorage.getItem('loggedInUser');
    return storedUser ? JSON.parse(storedUser) : null;
  }

  removeAuthTokenInfo(): void {
    localStorage.removeItem('authTokenInfo')
  }

  removeUser(): void {
    localStorage.removeItem('loggedInUser');
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  }

  isAuthenticated(): boolean {
    return (localStorage.getItem('loggedInUser') !== null) ? true : false;
  }

  checkUserPermission(permission: string): boolean {
    const user = this.getLoggedInUser();
    const roles: string[] = user?.['realm_access']?.['roles'] ?? [];
    return roles.includes(permission);
  }

  clearStorage(): void {
    localStorage.clear();
  }

}
